<dv-dynamic-form
  class="dynamic-form"
  [elements]="informationElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
<hr class="form-divider" />
<dv-dynamic-form
  class="dynamic-form-background"
  formTitle="{{ 'Asset.Notification' | translate | uppercase }}"
  [elements]="notificationElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
<hr class="form-divider" />
<dv-dynamic-form
  formTitle="{{ 'Asset.LastUpdates' | translate | uppercase }}"
  [elements]="lastUpdatesElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
<hr class="form-divider" />
<dv-save-panel
  [disableSave]="!formGroup.dirty || !formGroup.valid || !!isSaveInProgress"
  labelCancel=""
  labelSave="{{ 'General.Save' | translate }}"
  (save)="onSave()">
  @if (isInactiveFindTextVisible) {
    <div class="inactive-find-info">
      <b>{{ 'Asset.InactiveFindInfo' | translate }}</b>
    </div>
  }
</dv-save-panel>
